export default __webpack_public_path__ + "static/media/kitchen3-before3-1440w.401b9759.avif";